import React from 'react'
import { cilShieldAlt } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CButton, CTooltip } from '@coreui/react'
import ActionButton from 'src/components/ActionButton'
import roleList from '../stub/role.json'
import subRoleList from '../stub/subRole.json'
import {
  SUPERADMIN,
  ADMIN,
  CUSTOMER,
  DISTRIBUTOR,
  KETOAN,
  BAOHANH,
  KINHDOANH,
  ROLE,
  SUB_ROLE,
  PRODUCT,
  ACTIVED,
  EXPIRED,
  ACCOUNTANT_ACCESS,
  SALE_ACCESS,
  WARRANTY_ACCESS,
  DISTRIBUTOR_ACCESS,
  CUSTOMER_ACCESS,
} from 'src/constants'
import _nav from 'src/_nav'

export const getExactNav = () => {
  const role = sessionStorage.getItem(ROLE)
  const subRole = sessionStorage.getItem(SUB_ROLE)

  const isVerifyRole = [
    SUPERADMIN,
    ADMIN,
    DISTRIBUTOR,
    CUSTOMER,
    KETOAN,
    BAOHANH,
    KINHDOANH,
  ].includes(role?.toLowerCase() || subRole?.toLowerCase())

  let nav = []

  switch (role) {
    case SUPERADMIN:
      nav = _nav
      break

    case CUSTOMER:
      nav = _nav.filter((el) => CUSTOMER_ACCESS.includes(el?.to))
      break

    case ADMIN: {
      switch (subRole) {
        case ADMIN:
          nav = _nav
          break

        case KETOAN:
          nav = _nav.filter((el) => ACCOUNTANT_ACCESS.includes(el?.to))
          break
        case BAOHANH:
          nav = _nav.filter((el) => WARRANTY_ACCESS.includes(el?.to))
          break
        case KINHDOANH:
          nav = _nav.filter((el) => SALE_ACCESS.includes(el?.to))
          break

        default:
          break
      }
      break
    }

    case DISTRIBUTOR:
      nav = _nav.filter((el) => DISTRIBUTOR_ACCESS.includes(el?.to))
      break

    default:
      break
  }

  return { nav, isVerifyRole }
}

export const checkPermission = () => {
  const role = sessionStorage.getItem(ROLE)
  const subRole = sessionStorage.getItem(SUB_ROLE)
  let hasPermission = false

  switch (role) {
    case SUPERADMIN:
      hasPermission = true
      break

    case ADMIN: {
      switch (subRole) {
        case ADMIN:
          hasPermission = true
          break

        case KETOAN:
          hasPermission = true
          break
        case BAOHANH:
          hasPermission = true
          break

        default:
          hasPermission = false
          break
      }
      break
    }

    default:
      hasPermission = false
      break
  }
  return hasPermission
}

export const renderAction = (
  hasPermission,
  handleEdit,
  toggleDeleteConfirm,
  handleChange,
  flag,
  handleChangePass,
) => {
  const isSuperAdmin = window.sessionStorage.getItem(ROLE) === SUPERADMIN
  return [
    {
      key: 'action',
      dataIndex: 'action',
      title: 'Thao tác',
      render: (_, item) => {
        const noAction =
          flag === PRODUCT && [ACTIVED, EXPIRED].includes(item?.status) && !isSuperAdmin

        if (hasPermission && !noAction) {
          return (
            <ActionButton
              onEdit={() => handleEdit(item)}
              item={item}
              hasChange={Boolean(handleChange)}
              onDelete={() => toggleDeleteConfirm(item)}
              onChange={() => handleChange(item)}
              hasChangePass={Boolean(handleChangePass)}
              onChangePass={() => handleChangePass(item)}
            />
          )
        } else {
          return 'Không có quyền hạn!'
        }
      },
    },
  ]
}

export const renderActiveWarranty = (hasPermission, toggleConfirm) => {
  if (hasPermission) {
    return [
      {
        key: 'action',
        dataIndex: 'action',
        title: 'Thao tác',
        render: (_, item) => (
          <CTooltip content="Bảo hành">
            <CButton
              onClick={() => toggleConfirm(item)}
              className="rounded text-white"
              color="success"
            >
              <CIcon icon={cilShieldAlt} size="lg" />
            </CButton>
          </CTooltip>
        ),
      },
    ]
  } else {
    return [
      {
        key: 'action',
        dataIndex: 'action',
        title: 'Thao tác',
        render: () => 'Không có quyền hạn!',
      },
    ]
  }
}

export const getRoleLabel = () => {
  const role = sessionStorage.getItem(ROLE)
  const subRole = sessionStorage.getItem(SUB_ROLE)

  if (role && role === ADMIN) {
    if (subRole) {
      return subRoleList.filter((item) => item?.role === subRole)[0]?.label
    }
  } else if (role && role === SUPERADMIN) {
    return 'SuperAdmin'
  } else {
    return roleList.filter((item) => item?.role === role)[0]?.label
  }
}
